module.exports = {
	"name": "sisfebe-bancas",
	"description": "Um sistema para gestão de bancas de TCC.",
	"version": "1.0.0",
	"author": "Guilherme Passero <guilherme.passero@unifebe.edu.br>",
	"private": true,
	"scripts": {
		"dev": "cross-env NODE_ENV=development webpack-dev-server --open --hot",
		"build": "cross-env NODE_ENV=production webpack --progress --hide-modules",
		"buildtest": "cross-env NODE_ENV=test webpack --progress --hide-modules"
	},
	"dependencies": {
		"moment": "^2.20.1",
		"screenfull": "^3.3.2",
		"vee-validate": "^2.0.3",
		"vue": "^2.5.13",
		"vue-moment": "^2.2.0",
		"vue-resource": "^1.3.6",
		"vue-router": "^3.0.1",
		"vue-spinner": "^1.0.3",
		"vue-sweetalert": "^0.1.18",
		"vuetify": "^0.17.7",
		"vuex": "^3.0.1",
		"vuex-persistedstate": "^2.4.2",
		"xlsx": "^0.17.3"
	},
	"devDependencies": {
		"babel-core": "^6.26.0",
		"babel-loader": "^6.0.0",
		"babel-preset-env": "^1.6.1",
		"babel-preset-latest": "^6.0.0",
		"babel-preset-stage-2": "^6.24.1",
		"cross-env": "^3.0.0",
		"css-loader": "^0.25.0",
		"file-loader": "^0.9.0",
		"style-loader": "^0.18.2",
		"stylus": "^0.54.5",
		"stylus-loader": "^3.0.1",
		"vue-loader": "^11.1.4",
		"vue-template-compiler": "^2.5.13",
		"webpack": "^2.7.0",
		"webpack-dev-server": "^2.11.1"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 285
// module chunks = 0